// Canonical station list. Mirrors the keys used across PlayerContext, RadioPage,
// StationsPage, and admin dropdowns. Keep in sync with backend stations.
export const STATIONS = [
  { key: "truth-hiphop",         name: "Truth Hip-Hop" },
  { key: "worship",              name: "Worship" },
  { key: "study-instrumentals",  name: "Study Instrumentals" },
  { key: "sabbath-flow",         name: "Sabbath Flow" },
];

export const STATION_KEYS = STATIONS.map((s) => s.key);
